import Icon from '@mdi/react'
import {
    mdiAlertDecagram, mdiKeyVariant, mdiSnowflake,
    mdiLogin, mdiLogout, mdiLightningBolt, mdiAirplaneTakeoff,
    mdiCarDoor, mdiWeatherWindy, mdiThermometerLines, mdiAlert,
    mdiLock, mdiLockOff, mdiPowerPlugOff, mdiPowerPlug,
    mdiGasStationOutline, mdiGasStation, mdiBarrelOutline, mdiBarrel,
    mdiFuelCell,
} from '@mdi/js';

const eventIcons = (desc, size = 1) => {

    let icon = <Icon path={mdiAlertDecagram} size={size} color="blue" />;

    if (typeof desc === 'string' || desc instanceof String) {
        if (desc.toLowerCase().search("engine on") !== -1) {
            icon = <Icon path={mdiKeyVariant} size={size} color="teal" />
        }

        if (desc.toLowerCase().search("engine off") !== -1) {
            icon = <Icon path={mdiKeyVariant} size={size} color="grey" />
        }

        if (desc.toLowerCase().search("ac on") !== -1) {
            icon = <Icon path={mdiSnowflake} size={size} color="dodgerblue" />
        }

        if (desc.toLowerCase().search("ac off") !== -1) {
            icon = <Icon path={mdiSnowflake} size={size} color="grey" />
        }

        if (desc.toLowerCase().search("zone in") !== -1) {
            icon = <Icon path={mdiLogin} size={size} color="blue" />
        }

        if (desc.toLowerCase().search("zone out") !== -1) {
            icon = <Icon path={mdiLogout} size={size} color="tomato" />
        }

        if (desc.toLowerCase().search("generator on") !== -1) {
            icon = <Icon path={mdiLightningBolt} size={size} color="green" />
        }

        if (desc.toLowerCase().search("generator off") !== -1) {
            icon = <Icon path={mdiLightningBolt} size={size} color="grey" />
        }

        if (desc.toLowerCase().search("overspeed") !== -1) {
            icon = <Icon path={mdiAirplaneTakeoff} size={size} color="red" />
        }

        if (desc.toLowerCase().search("door open") !== -1) {
            icon = <Icon path={mdiCarDoor} size={size} color="red" />
        }

        if (desc.toLowerCase().search("door close") !== -1) {
            icon = <Icon path={mdiCarDoor} size={size} color="green" />
        }

        if (desc.toLowerCase().search("compressor on") !== -1) {
            icon = <Icon path={mdiSnowflake} size={size} color="blue" />
        }

        if (desc.toLowerCase().search("compressor off") !== -1) {
            icon = <Icon path={mdiSnowflake} size={size} color="grey" />
        }

        if (desc.toLowerCase().search("blower on") !== -1) {
            icon = <Icon path={mdiWeatherWindy} size={size} color="blue" />
        }

        if (desc.toLowerCase().search("blower off") !== -1) {
            icon = <Icon path={mdiWeatherWindy} size={size} color="grey" />
        }

        if (desc.toLowerCase().search("panic") !== -1) {
            icon = <Icon path={mdiAlert} size={size} color="red" />
        }

        if (desc.toLowerCase().search("temp") !== -1) {
            icon = <Icon path={mdiThermometerLines} size={size} color="red" />
        }

        if (desc.toLowerCase().search("locked") !== -1) {
            icon = <Icon path={mdiLock} size={size} color="red" />
        }

        if (desc.toLowerCase().search("unlocked") !== -1) {
            icon = <Icon path={mdiLockOff} size={size} color="green" />
        }

        if (desc.toLowerCase().search("cut off") !== -1) {
            icon = <Icon path={mdiPowerPlugOff} size={size} color="red" />
        }

        if (desc.toLowerCase().search("good") !== -1) {
            icon = <Icon path={mdiPowerPlug} size={size} color="green" />
        }

        if (desc.toLowerCase().search("filling") !== -1) {
            icon = <Icon path={mdiGasStationOutline} size={size} color="blue" />
        }

        if (desc.toLowerCase().search("filled") !== -1) {
            icon = <Icon path={mdiGasStation} size={size} color="indigo" />
        }

        if (desc.toLowerCase().search("theft") !== -1) {
            icon = <Icon path={mdiBarrelOutline} size={size} color="orange" />
        }

        if (desc.toLowerCase().search("stolen") !== -1) {
            icon = <Icon path={mdiBarrel} size={size} color="red" />
        }

        if (desc.toLowerCase().search("high burn") !== -1) {
            icon = <Icon path={mdiFuelCell} size={size} color="tomato" />
        }

        if (desc.toLowerCase().search("high burn start") !== -1) {
            icon = <Icon path={mdiFuelCell} size={size} color="violet" />
        }



    } else {
        //console.log("event icon desc", desc);
    }

    return icon;
}

export default eventIcons;